// @ts-nocheck
import {Column} from 'react-table'
import {SubscriptionStatusCell} from './SubscriptionStatusCell'
import { ProductModifier } from '@/app/modules/product-modifier/core/_models'
import { ProductModifierCustomHeader } from '@/app/modules/product-modifier/product-modifier-list/table/columns/ProductModifierCustomHeader'
import { formatIntl } from '@/app/utils'
import { TopupHistoryActionsCell } from './TopupHistoryActionsCell'
import moment from 'moment'

const productModifiersColumns: ReadonlyArray<Column<ProductModifier>> = [
  {
    Header: (props) => <ProductModifierCustomHeader tableProps={props} title='No' />,
    id: 'no',
    Cell: (props) => {
      return <label>{props.row.index + 1 + props.initialState.pageIndex * 10}</label>
    },
  },
  {
    Header: (props) => (
      <ProductModifierCustomHeader tableProps={props} title='Customer' className='min-w-125px' />
    ),
    accessor: 'customer_name',
  },
  {
    Header: (props) => (
      <ProductModifierCustomHeader tableProps={props} title='Customer' className='min-w-125px' />
    ),
    accessor: 'created_at',
    Cell: (props) => {
      return moment(props.value).format("DD MMMM YYYY")
    }
  },
  {
    Header: (props) => (
      <ProductModifierCustomHeader tableProps={props} title='Subtotal' className='min-w-125px' />
    ),
    accessor: 'total_subtotal',
    Cell: (props) => {
      return formatIntl({num: props.value, fraction: 0, showSign: true})
    }
  },
  {
    Header: (props) => (
      <ProductModifierCustomHeader tableProps={props} title='Discount' className='min-w-125px' />
    ),
    accessor: 'total_discount',
    Cell: (props) => {
      return formatIntl({num: props.value, fraction: 0, showSign: true})
    }
  },
  {
    Header: (props) => (
      <ProductModifierCustomHeader tableProps={props} title='Rounding' className='min-w-125px' />
    ),
    accessor: 'rounding',
    Cell: (props) => {
      return formatIntl({num: props.value, fraction: 0, showSign: true})
    }
  },
  {
    Header: (props) => (
      <ProductModifierCustomHeader tableProps={props} title='Grand Total' className='min-w-125px' />
    ),
    accessor: 'grandtotal',
    Cell: (props) => {
      return formatIntl({num: props.value, fraction: 0, showSign: true})
    }
  },
  {
    Header: (props) => (
      <ProductModifierCustomHeader tableProps={props} title='Status' className='min-w-125px' />
    ),
    accessor: 'status_transaction',
    Cell: ({...props}) => {
      const status = props.data[props.row.index].status_transaction
      // draft biru, published ijo
      let className = 'badge bg-light-secondary'
      if (status?.toLowerCase() === 'awaiting payment') {
        className = 'badge bg-light-warning text-warning'
      } else if (status?.toLowerCase() === 'completed') {
        className = 'badge bg-light-success text-success'
      }
      
      return (
        <label className={className}>{props.data[props.row.index].status_transaction}</label>
      )
    },
  },
  {
    Header: (props) => (
      <ProductModifierCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <TopupHistoryActionsCell id={props.data[props.row.index].guid} />,
  },
]

export {productModifiersColumns}